import Client from '../HttpClient';
import { systemSourceUrl } from '../../helpers/SystemSourceHelper';

const baseUrl = '/api/vs/manager';

const find = (systemSource, merchantId, branchId) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/reservationAgreements`
		),
		{
			branchId,
		}
	);
};

const update = (systemSource, merchantId, branchId, content, operateBy) => {
	return Client.post(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/reservationAgreements`
		),
		{
			branchId,
			content,
			operateBy,
			stopFlag: 0,
		}
	);
};

export default {
	find,
	update,
};
